// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__nqBu4","leftColumn":"Layout_leftColumn__H1Tcs","rightColumn":"Layout_rightColumn__r3dr-"};